import {MetaDataModel} from './meta-data.model';
import {PriceInfoModel} from './price-info.model';

// data about request for each device, in projectModel.requestedProductInfo.requestedProducts
// describe device request (which by sku and how much), so to right name should be DeviceRequestItemModel
export class RequestedDeviceItemModel {

    sku: string;
    amount: number;  // rest contains this value, but it si not used in app for calculation or communication with user

    metaData: MetaDataModel;

    // for internal user

    isPrintsmart: boolean;
    priceInfo: PriceInfoModel;



    public static getNewInstance(
        priceInfo = PriceInfoModel.getNewInstance(),
        metadata = new MetaDataModel()
    ): RequestedDeviceItemModel {

        const result = new RequestedDeviceItemModel();
        result.metaData = metadata;
        result.priceInfo = priceInfo;
        return result;
    }

}


